export default __webpack_public_path__ + "static/media/llave.760429f2.svg";